<template>
	<div class="but" v-if="antishake" :style="butStyle()" @click.stop="know">{{ text }}</div>
	<div class="but" v-else :style="butStyle()" @click.stop="knows">{{ text }}</div>
</template>

<script>
import { throttle } from "@/utils/index";
export default {
	props: {
		// 是否开启节流按钮 默认不开启
		antishake: {
			type: Boolean,
			default: true
		},
		// 判断是否可以点击
		flag: {
			type: Boolean,
			default: true
		},
		text: {
			type: String,
			default: ''
		},
		width: {
			type: String,
			default: '15rem' // 600rpx
		},
		height: {
			type: String,
			default: '2.5rem' // 100rpx
		},
		fontSize: {
			type: String,
			default: '0.7rem' // 28rpx
		},
		radius: {
			type: String,
			default: '1.25rem' // 50rpx
		},
		color: {
			type: String,
			default: '#FFDB89'
		},
		background: {
			type: String,
			default: 'linear-gradient( 87deg, #1D1D1D 0%, #5B4E3F 100%)'
		},
		border: {
			type: String,
			default: ''
		},
		marginTop: {
			type: String,
			default: '0'
		},
		// 是否居中
		center: false,
		bold: false

	},
	data() {
		return {
			abc: 1000
		}
	},
	methods: {
		know() {
			if (this.flag) {
				this.$emit('know')
			} else {
				this.$emit('forbidden') // 禁止点击触发
			}
		},
		knows: throttle(function () {
			if (this.flag) {
				this.$emit('know')
			} else {
				this.$emit('forbidden') // 禁止点击触发
			}
		}, 1000),
		butStyle() {
			let style = {
				width: this.width,
				height: this.height,
				fontSize: this.fontSize,
				color: this.color,
				borderRadius: this.radius,
				background: this.background,
				border: this.border,
				margin: `${this.marginTop} 0 0 0`,
				lineHeight: this.height,
				fontWeight: this.bold ? 'bold' : 'normal'
			}
			if (this.center) {
				style.margin = `${this.marginTop} auto 0`
			}
			return style
		}
	}
}
</script>

<style lang="scss" scoped>
.but {
	width: 15rem; // 600rpx
	height: 2.5rem; // 100rpx
	// background: #FE6254;
	border-radius: 1.25rem; // 50rpx
	font-size: 0.7rem; // 28rpx
	color: #fff;
	text-align: center;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
}
</style>